import { useTranslation as useReactI18nextTranslation } from "next-i18next";

import { formatPrice } from "./selectors";
import { useTenant } from "~/tenant/hooks";

export function useTranslation() {
  const { t } = useReactI18nextTranslation();

  return t;
}

export function usePrice() {
  const { country, flags } = useTenant();
  const hideDecimals = Boolean(flags?.includes("hideDecimals"));

  return (price: number, format?: "locale" | "iso") =>
    formatPrice(price, country, format, hideDecimals);
}
